import React from 'react';
import { getFlagByCode } from '../../utils/flagUtils';

const GlobeIcon = ({ className = '', title = 'Unknown region' }) => (
    <svg
        className={className}
        data-unknown-flag="true"
        viewBox="0 0 512 512"
        fill="currentColor"
        aria-label={title}
        role="img"
    >
        <path d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64h185.4c2.1 20.4 3.3 41.8 3.3 64zm28.8-64h123.1c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6C399.3 29.7 463.4 85.7 493.4 160zM344.3 160H167.7c6.1-36.4 15.5-68.6 27-94.7C211.8 26.6 233.4 0 256 0s44.2 26.6 61.3 65.3c11.6 26.1 20.9 58.3 27 94.7zm-209 0H18.6C48.6 85.7 112.7 29.7 190.6 8.4c-25.5 34.2-45.3 87.7-55.3 151.6zM8.1 192h123.1c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zm186.6 254.6c-11.6-26-20.9-58.2-27-94.6h176.6c-6.1 36.4-15.5 68.6-27 94.6C300.2 485.4 278.6 512 256 512s-44.2-26.6-61.3-65.4zM190.6 503.6C112.7 482.3 48.6 426.3 18.6 352h116.7c10 63.9 29.8 117.4 55.3 151.6zm130.8 0c25.5-34.2 45.3-87.7 55.3-151.6h116.7c-30 74.3-94.1 130.3-172 151.6z" />
    </svg>
);

const FlagIcon = ({ siteSettings, code, className = '', alt = 'Flag' }) => {
    const flagCode = code || siteSettings?.selectedFlag || 'unknown';

    if (flagCode === 'unknown') {
        return <GlobeIcon className={className} title={alt} />;
    }

    const flagSrc = getFlagByCode(flagCode);

    if (!flagSrc) {
        return <GlobeIcon className={className} title="Unknown region" />;
    }

    return <img src={flagSrc} alt={alt} className={className} />;
};

export default FlagIcon;
